import { AuthEndpoints } from './endpoints';
import { UserAuthSchema, UserSchema, ValidateTokenSchema } from './schemas';
import { User } from '../models/users';
import * as net from '~/lib/net';


export async function login(username: string, password: string): Promise<User> {
  // TODO: We expect that authentication token is stored in a cookie.
  // If it's expected in a header - we'll have to store it in memory, but
  // not in the localStorage/sessionStorage.
  // More here: https://auth0.com/docs/security/store-tokens
  const data = await net.apiPost(AuthEndpoints.login(), null, {
    username,
    password,
  });

  return UserAuthSchema.load(data);
}

export function logout(): Promise<boolean> {
  /*
   return fetch(AuthEndpoints.logout(), {
     method: 'POST',
     credentials: 'include'
   });
   */

  return Promise.resolve(true);
}

export async function checkAuth(token: string): Promise<User> {
  const payload = ValidateTokenSchema.save({ token });

  const data = await net.apiPost(AuthEndpoints.validate(), null, payload);

  // TODO: Server should return an error if token is invalid
  if (data) {
    return UserSchema.load(data);
  }

  return null;
}

export async function forcePasswordChange(username: string, password: string, newPassword: string, acceptTerms: boolean): Promise<User> {
  const data = await net.apiPost(AuthEndpoints.forcePasswordChange(), null, {
    username,
    password,
    new_password: newPassword,
    accept_terms: acceptTerms,
  });

  return UserAuthSchema.load(data);
}

